"use strict";

var _toConsumableArray = require("/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chainIdFromRecipient = exports.normalizeAssetId = exports.fee = exports.networkByte = exports.isOrder = exports.convertToPairs = exports.addProof = exports.base64Prefix = exports.getSenderPublicKey = exports.mapObj = void 0;

var ts_lib_crypto_1 = require("@waves/ts-lib-crypto");

exports.mapObj = function (obj, f) {
  return Object.entries(obj).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return [k, f(v)];
  }).reduce(function (acc, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        k = _ref4[0],
        v = _ref4[1];

    return Object.assign(Object.assign({}, acc), _defineProperty({}, k, v));
  }, {});
};

function getSenderPublicKey(seedsAndIndexes, params) {
  if (seedsAndIndexes.length === 0 && params.senderPublicKey == null) throw new Error('Please provide either seed or senderPublicKey');else {
    return params.senderPublicKey == null ? ts_lib_crypto_1.publicKey(seedsAndIndexes[0][0]) : params.senderPublicKey;
  }
}

exports.getSenderPublicKey = getSenderPublicKey;

exports.base64Prefix = function (str) {
  return str == null || str.slice(0, 7) === 'base64:' ? str : 'base64:' + str;
};

function addProof(tx, proof, index) {
  if (index == null) {
    tx.proofs = [].concat(_toConsumableArray(tx.proofs), [proof]);
    return tx;
  }

  if (tx.proofs != null && !!tx.proofs[index]) throw new Error("Proof at index ".concat(index, " already exists."));

  for (var i = tx.proofs.length; i < index; i++) {
    tx.proofs.push('');
  }

  tx.proofs[index] = proof;
  return tx;
}

exports.addProof = addProof;

function convertToPairs(seedObj) {
  //Due to typescript duck typing, 'string' type satisfies IIndexSeedMap interface. Because of this we should typecheck against string first
  if (seedObj == null) {
    return [];
  } else if (typeof seedObj === 'string') {
    return [[seedObj, undefined]];
  } else if ('privateKey' in seedObj) {
    return [[seedObj, undefined]];
  } else if (Array.isArray(seedObj)) {
    return seedObj.map(function (s, i) {
      return [s, i];
    }).filter(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          s = _ref6[0],
          _ = _ref6[1];

      return s;
    });
  } else {
    var keys = Object.keys(seedObj).map(function (k) {
      return parseInt(k);
    }).filter(function (k) {
      return !isNaN(k);
    }).sort();
    return keys.map(function (k) {
      return [seedObj[k], k];
    });
  }
}

exports.convertToPairs = convertToPairs;

exports.isOrder = function (p) {
  return p.assetPair !== undefined;
};

function networkByte(p, def) {
  switch (typeof p) {
    case 'string':
      return p.charCodeAt(0);

    case 'number':
      return p;

    default:
      return def;
  }
}

exports.networkByte = networkByte;

function fee(params, def) {
  if (params.fee) return params.fee;
  if (!params.additionalFee) return def;
  return def + params.additionalFee;
}

exports.fee = fee;

function normalizeAssetId(assetId) {
  assetId = assetId || null;
  return assetId === 'WAVES' ? null : assetId;
}

exports.normalizeAssetId = normalizeAssetId;

function chainIdFromRecipient(recipient) {
  if (recipient.startsWith('alias')) {
    return recipient.charCodeAt(6);
  } else {
    try {
      return ts_lib_crypto_1.base58Decode(recipient)[1];
    } catch (e) {
      throw new Error("Invalid recipient: ".concat(recipient));
    }
  }
}

exports.chainIdFromRecipient = chainIdFromRecipient;